import { FadeIn } from "./ui";
import { Mic, ArrowUpRight } from "lucide-react";

export function Podcast() {
  return (
    <section id="podcast" className="relative py-32 overflow-hidden bg-brand-accent text-brand-dark">
      <div className="absolute inset-0 bg-paper opacity-20 pointer-events-none mix-blend-multiply"></div>
      
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <FadeIn>
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-brand-dark text-brand-light mb-8">
              <Mic className="w-10 h-10" />
            </div>
            
            <h2 className="text-5xl md:text-7xl font-black uppercase tracking-tighter mb-6 leading-[0.9]">
              Entre <br/>
              <span className="font-highlight italic text-brand-light lowercase font-normal">estratégias</span> <br/>
              & histórias
            </h2>
            <p className="text-xl md:text-2xl text-brand-dark/80 mb-10 font-medium max-w-lg">
              Toda semana compartilhamos insights e estratégias sobre marketing, negócios e inovação.
            </p>
            
            <a href="https://open.spotify.com/show/4hmRBolm3Y0FvCBfKjjkMq?si=2DJYMaMFSUmehY-gJv4cNA" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-brand-dark font-bold uppercase tracking-widest hover:text-brand-light transition-colors border-b-2 border-brand-dark hover:border-brand-light pb-1">
              Ouvir todos os episódios <ArrowUpRight className="w-6 h-6" />
            </a>
          </FadeIn>

          <FadeIn delay={0.2}>
            <div className="w-full relative transition-transform duration-500 rounded-2xl overflow-hidden shadow-2xl hover:shadow-[0_30px_60px_rgba(0,0,0,0.2)]">
              <iframe
                data-testid="embed-iframe"
                title="Player do podcast P2A no Spotify"
                style={{ borderRadius: "12px", background: "transparent" }}
                src="https://open.spotify.com/embed/show/4hmRBolm3Y0FvCBfKjjkMq?utm_source=generator&theme=0"
                width="100%"
                height="352"
                frameBorder="0"
                allowFullScreen={false}
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
              ></iframe>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}
